var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-layout"},[_c('toolbar'),_c('category-bar'),_c('div',{staticClass:"default-layout__inner"},[_vm._t("default")],2),_c('footer-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }